import {svgIconWrapper} from '../svg-icon-wrapper';

import IntercomRegular from './intercom-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <IntercomRegular {...props} />;
}

SvgComponent.iconName = 'intercomRegular';

export const IntercomRegularIcon = svgIconWrapper(SvgComponent);
